import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdClose, MdQrCodeScanner } from "react-icons/md";
import { QRCodeCanvas } from "qrcode.react";
import { Button, Modal } from "rsuite";
import { IoCloudDownloadOutline } from "react-icons/io5";
import logo from "../../../assets/images/easypaylogoblack.png";
import ondcLogo from "../../../assets/images/ONDC_logo.png";
import OKLogo from "../../../assets/images/logo OK.png";
import "./QrModal.scss";
import { styles } from "../pages/StoreQr/StoreQrModal";
import {
  Document,
  Image,
  Link,
  Page,
  PDFDownloadLink,
  Text,
  View,
} from "@react-pdf/renderer";

const HeaderStorePdfDocument = ({ storeList, qrDataUrl, storeName, pdfStrings }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.cardWrapper}>
        <Text style={styles.storeName}>{storeName}</Text>
        <Text style={styles.scanQrText}>{pdfStrings.scanQrCode}</Text>
        {qrDataUrl && storeList?.sellerStoreLink && (
          <Link src={storeList.sellerStoreLink}>
            <Image style={styles.qrCode} src={qrDataUrl} />
          </Link>
        )}
        <Text style={styles.catologText}>{pdfStrings.catalogPoweredBy}</Text>
        <View style={styles.logoRow}>
          <Image src={logo} style={styles.logo} />
          <Image src={ondcLogo} style={styles.logo} />
        </View>
      </View>
      {storeList?.sellerStoreLink && (
        <Link src={storeList.sellerStoreLink} style={styles.storeLink}>
          {pdfStrings.clickToOpenStore}
        </Link>
      )}
    </Page>
  </Document>
);

const QrModal = ({ isVisible, onClose, sellerData }) => {
  const { t } = useTranslation();
  const qrCardRef = useRef();
  const [qrDataUrl, setQrDataUrl] = useState(null);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        const canvas = document.getElementById("qr-canvas");
        if (canvas) {
          setQrDataUrl(canvas.toDataURL("image/png"));
        }
      }, 300);
    }
  }, [isVisible]);

  return (  
    <Modal
      open={isVisible}
      onClose={onClose}
      keyboard={false}
      className="qr-modal"
    >
      <div className="close-button" onClick={onClose}>
        <MdClose />
      </div>
      <Modal.Header>
        <div className="qr-modal-header">
          <div className="qr-title-container">
            <MdQrCodeScanner className="qr-icon" />
            <Modal.Title className="qr-title">
              {t("qrModal.title")}
            </Modal.Title>
          </div>
          <Button
            appearance="primary"
            className="download-button"
            disabled={!sellerData?.storeSetting?.sellerStoreLink}
          >
            {qrDataUrl && (
              <PDFDownloadLink
                document={
                  <HeaderStorePdfDocument
                    storeList={sellerData?.storeSetting}
                    qrDataUrl={qrDataUrl}
                    storeName={sellerData?.storeName}
                    pdfStrings={{
                      scanQrCode: t("qrModal.scanQrCode"),
                      catalogPoweredBy: t("qrModal.catalogPoweredBy"),
                      clickToOpenStore: t("qrModal.clickToOpenStore"),
                    }}
                  />
                }
                fileName={`${sellerData?.storeName || "catalog"}.pdf`}
                style={{ textDecoration: "none" }}
              >
                {({ loading }) => (
                  <Button
                    className="download-button"
                    startIcon={<IoCloudDownloadOutline />}
                  >
                    {loading ? t("qrModal.preparing") : t("qrModal.download")}
                  </Button>
                )}
              </PDFDownloadLink>
            )}
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        {sellerData?.storeSetting?.sellerStoreLink ? (
          <div className="qr-card" ref={qrCardRef}>
            <div className="qr-primary-text">{sellerData?.storeName}</div>
            <div className="qr-secondary-text">
              {t("qrModal.scanQrCode")}
            </div>
            <div className="qr-code-container">
              <a
                href={sellerData?.storeSetting?.sellerStoreLink}
                target="_blank"
                rel="noopener noreferrer"
                className="qr-link"
              >
                <QRCodeCanvas
                  id="qr-canvas"
                  value={sellerData?.storeSetting?.sellerStoreLink}
                  size={180}
                  level="H"
                  imageSettings={{
                    src: OKLogo,
                    height: 70,
                    width: 70,
                    excavate: true,
                  }}
                />
                <span className="qr-hover-text">{t("qrModal.scanOrClick")}</span>
              </a>
            </div>
            <div className="qr-footer">
              <span>{t("qrModal.catalogPoweredBy")}</span>
              <div className="qr-footer-logos">
                <img src={logo} alt="Easy Pay" />
                <img src={ondcLogo} alt="ONDC" />
              </div>
            </div>
          </div>
        ) : (
          <div className="not-qr-text">
            {t("qrModal.notGenerated")}
          </div>
        )}
        {sellerData?.storeSetting?.sellerStoreLink && (
          <div className="qr-share-text">
            {t("qrModal.shareText")}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default QrModal;
